import { BarMitzvahType } from 'types/types'

function formatBarMitzvah(barMitzvah: BarMitzvahType): string {
  return `${barMitzvah.student.firstName} ${barMitzvah.student.lastName} (${barMitzvah.date})`
}

export { formatBarMitzvah }
